export class UserTwoFaEnabledRequest {
  enabled: boolean;
}
